(() => {
  if (window.__ocButtonsLiveSearchStable) return;
  window.__ocButtonsLiveSearchStable = true;

  const states = new WeakMap();
  let indexPromise = null;
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const collectionHandle = 'see-all-our-pins-here';
  const SEARCH_DEBOUNCE_MS = 75;
  const MAX_RENDERED_RESULTS = 120;

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  const fetchButtonPage = async (page) => {
    const url = `${rootUrl}collections/${collectionHandle}/products.json?limit=250&page=${page}`;
    const response = await fetch(url, { credentials: 'same-origin', cache: 'force-cache' });
    if (!response.ok) throw new Error('Button index unavailable');
    const data = await response.json();
    return Array.isArray(data.products) ? data.products : [];
  };

  const prepareButtonIndex = (products) => {
    products.forEach((product) => {
      product.__ocSearchTitle = String(product.title || '').toLocaleLowerCase();
    });
    return products;
  };

  const loadButtonIndex = async () => {
    if (indexPromise) return indexPromise;
    indexPromise = (async () => {
      const firstBatch = await fetchButtonPage(1);
      const products = [...firstBatch];
      if (firstBatch.length < 250) return prepareButtonIndex(products);

      for (let start = 2; start <= 12; start += 2) {
        const pages = [];
        for (let page = start; page <= Math.min(12, start + 1); page += 1) pages.push(page);
        const batches = await Promise.all(pages.map(fetchButtonPage));
        let reachedEnd = false;

        for (const batch of batches) {
          products.push(...batch);
          if (batch.length < 250) {
            reachedEnd = true;
            break;
          }
        }
        if (reachedEnd) break;
      }

      return prepareButtonIndex(products);
    })();
    return indexPromise;
  };

  const getElements = (wrap) => ({
    wrap,
    anchor: wrap.parentElement && wrap.parentElement.querySelector('[data-oc-buttons-search-anchor]'),
    form: wrap.querySelector('[data-oc-buttons-search-form]'),
    input: wrap.querySelector('[data-oc-button-term]'),
    clear: wrap.querySelector('[data-oc-buttons-clear]'),
    status: wrap.querySelector('[data-oc-buttons-search-status]'),
    productCount: document.getElementById('ProductCountDesktop'),
    grid: document.getElementById('product-grid'),
    pager: document.querySelector('[data-oc-pagerbar]'),
    nativePager: document.querySelector('[data-oc-native-pagination]')
  });

  const getState = (wrap) => {
    let state = states.get(wrap);
    const els = getElements(wrap);
    if (!els.form || !els.input || !els.grid) return null;
    if (!state) {
      state = { ...els, timer: 0, originalGrid: null, pagerWasHidden: null, nativePagerWasHidden: null, browseScrollY: 0, searching: false, jumpPending: false, baseCountText: '' };
      states.set(wrap, state);
    } else Object.assign(state, els);
    return state;
  };

  const setStatus = (state, text) => {
    if (state.status) state.status.textContent = text || '';
    if (!state.productCount) return;
    const base = state.baseCountText || state.productCount.textContent.trim();
    state.productCount.textContent = text ? `${base} ${text}` : base;
  };
  const syncClear = (state) => {
    if (!state || !state.clear || !state.input) return;
    const visible = state.input.value.length > 0;
    state.clear.classList.toggle('is-visible', visible);
    state.clear.setAttribute('aria-hidden', visible ? 'false' : 'true');
    state.clear.tabIndex = visible ? 0 : -1;
  };
  const dockY = (state) => {
    const anchor = state.anchor || state.wrap;
    const stickyTop = parseFloat(getComputedStyle(state.wrap).top) || 0;
    return Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - stickyTop);
  };
  const beginSearch = (state) => {
    if (state.searching) return;
    state.baseCountText = state.productCount ? state.productCount.textContent.trim() : '';
    state.originalGrid = state.grid.innerHTML;
    state.pagerWasHidden = state.pager ? state.pager.hidden : null;
    state.nativePagerWasHidden = state.nativePager ? state.nativePager.hidden : null;
    state.browseScrollY = window.scrollY;
    state.searching = true;
    state.jumpPending = true;
  };
  const hidePaging = (state) => { if (state.pager) state.pager.hidden = true; if (state.nativePager) state.nativePager.hidden = true; };
  const restore = (state) => {
    clearTimeout(state.timer);
    if (state.originalGrid !== null) state.grid.innerHTML = state.originalGrid;
    if (state.pager && state.pagerWasHidden !== null) state.pager.hidden = state.pagerWasHidden;
    if (state.nativePager && state.nativePagerWasHidden !== null) state.nativePager.hidden = state.nativePagerWasHidden;
    const y = state.browseScrollY;
    state.originalGrid = null; state.pagerWasHidden = null; state.nativePagerWasHidden = null; state.searching = false; state.jumpPending = false;
    setStatus(state, '');
    state.baseCountText = '';
    requestAnimationFrame(() => {
      window.scrollTo({ top: y, left: 0, behavior: 'auto' });
      try { state.input.focus({ preventScroll: true }); } catch (_) { state.input.focus(); }
    });
  };
  const productImage = (product) => {
    if (product && product.images && product.images.length) { const first = product.images[0]; return typeof first === 'string' ? first : (first.src || ''); }
    return product && product.image ? (product.image.src || product.image) : '';
  };
  const productPrice = (product) => {
    const variant = product && product.variants && product.variants[0];
    const raw = variant && variant.price != null ? Number(variant.price) : NaN;
    return Number.isFinite(raw) ? `$${raw.toFixed(2)} USD` : '';
  };
  const renderCard = (product) => {
    const title = escapeHtml(product.title);
    const handle = encodeURIComponent(product.handle || '');
    const href = `${rootUrl}products/${handle}`;
    const image = escapeHtml(productImage(product));
    const price = escapeHtml(productPrice(product));
    const titleLength = String(product.title || '').length;
    const titleClass = titleLength > 70 ? ' oc-card-title--xlong' : titleLength > 48 ? ' oc-card-title--long' : '';
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const variant = variants.find((item) => item && item.available !== false) || variants[0] || null;
    const variantId = variant && variant.id != null ? String(variant.id) : '';
    const available = Boolean(variantId) && variant?.available !== false;
    const formId = `oc-live-search-add-${String(product.id || handle).replace(/[^a-zA-Z0-9_-]/g, '')}`;
    const quickAdd = variantId
      ? `<div class="quick-add no-js-hidden"><product-form><form method="post" action="${rootUrl}cart/add" id="${formId}" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="id" value="${escapeHtml(variantId)}" class="product-variant-id"${available ? '' : ' disabled'}><button id="${formId}-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-label="${available ? `Add ${title} to cart` : `${title} sold out`}" aria-live="polite" data-sold-out-message="true"${available ? '' : ' disabled'}><span>${available ? 'ADD TO CART' : 'SOLD OUT'}</span><span class="sold-out-message hidden">SOLD OUT</span><div class="loading__spinner hidden"></div></button></form></product-form></div>`
      : '';

    return `<li class="grid__item oc-button-json-result"><div class="card-wrapper product-card-wrapper underline-links-hover"><div class="card card--standard card--media"><div class="card__inner color-background-1 gradient ratio" style="--ratio-percent:100%;"><div class="card__media"><div class="media media--transparent media--hover-effect">${image ? `<img src="${image}" alt="${title}" loading="lazy" width="600" height="600">` : ''}</div></div></div><div class="card__content"><div class="card__information"><h3 class="card__heading h5${titleClass}"><a href="${href}" class="full-unstyled-link">${title}</a></h3>${price ? `<div class="card-information"><span class="price-item price-item--regular">${price}</span></div>` : ''}</div>${quickAdd}</div></div></div></li>`;
  };

  const runSearch = async (wrap) => {
    const state = getState(wrap); if (!state) return;
    const term = state.input.value.trim();
    if (!term) { if (state.searching) restore(state); return; }
    beginSearch(state); hidePaging(state); setStatus(state, 'SEARCHING…');
    try {
      const products = await loadButtonIndex();
      if (!state.searching || state.input.value.trim() !== term) return;
      const needle = term.toLocaleLowerCase();
      const matches = products.filter((product) => product.__ocSearchTitle.includes(needle));
      if (!state.searching || state.input.value.trim() !== term) return;
      if (matches.length) {
        const visibleMatches = matches.slice(0, MAX_RENDERED_RESULTS);
        state.grid.innerHTML = visibleMatches.map(renderCard).join('');
        const matchLabel = `${matches.length} MATCH${matches.length === 1 ? '' : 'ES'}`;
        setStatus(state, matches.length > MAX_RENDERED_RESULTS ? `${matchLabel} — SHOWING FIRST ${MAX_RENDERED_RESULTS}` : matchLabel);
      }
      else { state.grid.innerHTML = '<li class="grid__item oc-buttons-no-results"><span>NO BUTTONS FOUND</span></li>'; setStatus(state, '0 MATCHES'); }
      if (state.jumpPending) { state.jumpPending = false; const y = dockY(state); requestAnimationFrame(() => window.scrollTo({ top: y, left: 0, behavior: 'auto' })); }
    } catch (error) {
      console.error('OMNI-CULT button index search failed', error);
      state.grid.innerHTML = '<li class="grid__item oc-buttons-no-results"><span>BUTTON SEARCH UNAVAILABLE</span></li>'; setStatus(state, 'SEARCH UNAVAILABLE');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest && event.target.closest('[data-oc-buttons-search-form]');
    if (!form) return;
    event.preventDefault();
    const wrap = form.closest('[data-oc-buttons-live-search]'); if (!wrap) return;
    const state = getState(wrap); if (state) clearTimeout(state.timer); runSearch(wrap);
  }, true);
  document.addEventListener('input', (event) => {
    const input = event.target.closest && event.target.closest('[data-oc-button-term]'); if (!input) return;
    const wrap = input.closest('[data-oc-buttons-live-search]'); if (!wrap) return;
    const state = getState(wrap); if (!state) return;
    syncClear(state);
    clearTimeout(state.timer);
    if (!input.value.trim()) { if (state.searching) restore(state); return; }
    state.timer = window.setTimeout(() => runSearch(wrap), SEARCH_DEBOUNCE_MS);
  });
  document.addEventListener('click', (event) => {
    const clear = event.target.closest && event.target.closest('[data-oc-buttons-clear]');
    if (!clear) return;
    event.preventDefault();
    const wrap = clear.closest('[data-oc-buttons-live-search]');
    const state = wrap && getState(wrap);
    if (!state) return;
    state.input.value = '';
    syncClear(state);
    state.input.dispatchEvent(new Event('input', { bubbles: true }));
    try { state.input.focus({ preventScroll: true }); } catch (_) { state.input.focus(); }
  });

  document.addEventListener('search', (event) => {
    const input = event.target.closest && event.target.closest('[data-oc-button-term]'); if (!input || input.value.trim()) return;
    const wrap = input.closest('[data-oc-buttons-live-search]'); const state = wrap && getState(wrap); if (state && state.searching) restore(state);
  }, true);

  document.querySelectorAll('[data-oc-buttons-live-search]').forEach((wrap) => {
    const state = getState(wrap);
    if (state) syncClear(state);
  });

  const warm = () => loadButtonIndex().catch(() => {});
  if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 1200 });
  else window.setTimeout(warm, 450);
})();